<template>
    <div>
        <button-white @click="open">
            Bearbeiten
        </button-white>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    Ausstattung bearbeiten
                </template>


                <div class="flex justify-end" v-show="!loading">
                    <postable-equipment-delete :equipment="equipment" @leaveModal="setModalFalse"></postable-equipment-delete>
                </div>

                <input-text v-model="name" class="mb-8">
                    Name der Ausstattung
                </input-text>

                <input-text v-model="quantity" class="mb-4" type="number">
                    Anzahl
                    <template slot="helper">
                        Verfügbare Anzahl an Ausstattungen. Ausstattung ist nichtmehr zubuchbar, wenn
                        keins mehr für den Zeitpunkt vorhanden ist.
                    </template>
                </input-text>

                <div class="flex justify-end">
                    <button-primary @click="save">
                        <i class="fa fa-save mr-2"></i> Speichern
                    </button-primary>
                </div>

                <loading v-show="loading"></loading>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonWhite from "../UI/ButtonWhite.vue";
import Modal from "../Modal.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import InputText from "../UI/InputText.vue";
import Loading from "../UI/Loading.vue";
import PostableEquipmentDelete from "./PostableEquipmentDelete.vue";

export default {
    name: "PostableEquipmentEdit",

    components: {Loading, InputText, ButtonPrimary, Modal, ButtonWhite, PostableEquipmentDelete},

    props: ['equipment'],

    data: () => ({
        showModal: false,
        loading: false,
        name: '',
        quantity: 0,
    }),


    methods: {

        setModalFalse(){
            this.showModal = false;
            this.$emit('updated');
        },

        open() {
            this.showModal = true;
            this.name = this.equipment.name;
            this.quantity = this.equipment.quantity;
        },
        save() {
            this.loading = true;
            this.$http
                .post(`/admin/postable_equipment/${this.equipment.id}`, {
                    _method: 'put',
                    name: this.name,
                    quantity: this.quantity,
                })
                .then(() => {
                    this.loading = false;
                    this.$emit('updated');
                    this.$root.$emit('alert', 'Gespeichert.');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
    },
}
</script>

<style scoped>

</style>
